
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 17.583v.625a.624.624 0 01-.183.442l-4.166 4.167a.624.624 0 01-.442.183h-.625v-4.792a.63.63 0 01.625-.625h4.792z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M22.708 7.167h-6.25v1.875A1.46 1.46 0 0115 10.5a1.46 1.46 0 01-1.458-1.458V7.167h-6.25A2.29 2.29 0 005 9.458v11.25A2.29 2.29 0 007.292 23H18.75v-4.792a1.46 1.46 0 011.458-1.458H25V9.458a2.29 2.29 0 00-2.292-2.291zM16.667 19.25H8.958a.625.625 0 010-1.25h7.709a.625.625 0 010 1.25zm4.375-3.333H8.958a.625.625 0 010-1.25h12.084a.625.625 0 010 1.25zm0-3.334H8.958a.625.625 0 010-1.25h12.084a.625.625 0 010 1.25z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M15 9.667a.625.625 0 01-.625-.625V5.917a.625.625 0 011.25 0v3.125c0 .345-.28.625-.625.625z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M15 6.333c-.918 0-1.666-.747-1.666-1.666 0-.92.748-1.667 1.667-1.667s1.666.748 1.666 1.667-.747 1.666-1.666 1.666z","fill":"#B4BCCF"}})])
          )
        }
      }
    